let uniqueId = 0;

type RequestCallback = (requestId: number) => void;

export function patchXMLHTTPRequest(beforeXHRSendCb: RequestCallback, onRequestCompletedCb: RequestCallback) {
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.send = function (...args) {
        const requestId = uniqueId++;

        beforeXHRSendCb(requestId);

        this.addEventListener('readystatechange', () => {
            if (this.readyState === 4) {
                onRequestCompletedCb(requestId);
            }
        });

        return originalSend.apply(this, args);
    };
}

export function patchFetch(beforeRequestCb: RequestCallback, afterRequestCb: RequestCallback) {
    const originalFetch = fetch;

    window.fetch = (...args) => {
        return new Promise((resolve, reject) => {
            const requestId = uniqueId++;

            beforeRequestCb(requestId);
            originalFetch(...args).then(
                response => {
                    afterRequestCb(requestId);

                    resolve(response);
                },
                (error: unknown) => {
                    afterRequestCb(requestId);
                    reject(error);
                }
            );
        });
    };
}

export function isLongtaskPerformanceEntry(entry: PerformanceEntry) {
    return entry.entryType === 'longtask';
}

export function isResourcePerformanceEntry(entry: PerformanceEntry): entry is PerformanceResourceTiming {
    return entry.entryType === 'resource';
}
